import { Controller } from "stimulus";
import StimulusReflex from "stimulus_reflex";
import WaveSurfer from "wavesurfer.js"

export default class extends Controller {
  static targets = ["output", "hiddenText"];
  
  initialize() {
    
    if (this.element.dataset.audioUrl) {
      this.wavesurfer = WaveSurfer.create({
      container: '#waveform',
      waveColor: "rgba(228, 231, 235, 1)",
      progressColor: "rgba(121, 135, 155, 1)",
      cursorColor: "black",

    })
    this.wavesurfer.load(this.element.dataset.audioUrl);
    let button = document.getElementById('playButton');
    
    // Show loading message when loading starts
    this.wavesurfer.on('loading', function() {
      document.getElementById('waveform-loading').style.display = 'block';
      document.getElementById('waveform-loaded').style.display = 'none';
    });

    // Hide loading message when waveform is ready
    this.wavesurfer.on('ready', function() {
      document.getElementById('waveform-loading').style.display = 'none';
      document.getElementById('waveform-loaded').style.display = 'flex';
    });
    
    /** When the audio starts playing */
    this.wavesurfer.on('play', () => {
      button.innerHTML='<i class="fas fa-pause"></i> Pause audio'
    })

    /** When the audio pauses */
    this.wavesurfer.on('pause', () => {
      button.innerHTML='<i class="fas fa-play"></i> Play audio'
    })

    /** When the audio finishes playing */
    this.wavesurfer.on('finish', () => {
      button.innerHTML='<i class="fas fa-play"></i> Play audio'
    })

    }
 
  }

  connect() {
    StimulusReflex.register(this);
    this.element.addEventListener("shown.bs.modal", this.modal_shown.bind(this));
    document.addEventListener('initiate-download', this.initiateDownload)
  }

  disconnect() {
    document.removeEventListener('initiate-download', this.initiateDownload)
  }

  initiateDownload(event) {
    const url = event.detail.url
    window.location.href = url
  }

  modal_shown(event) {
    event.preventDefault();
    this.stimulate("TranscriptionReflex#show_full_text");
  }

  show_mood_text(event) {
    event.preventDefault();
    this.stimulate("TranscriptionReflex#show_mood_text");
  }

  show_safeguarding_text(event) {
    event.preventDefault();
    this.stimulate("TranscriptionReflex#show_safeguarding_text");
  }

  play_audio(event) { 

    event.preventDefault();
    if (window.recordingPlayed !== this.element.dataset.uuid) {
      this.stimulate("TranscriptionReflex#play_audio");
      window.recordingPlayed = this.element.dataset.uuid;
    }
    this.wavesurfer.playPause();
    
  }

  show_summary(event) {
    event.preventDefault();
    this.stimulate("TranscriptionReflex#show_summary");
  }

  beforeReflex (element, reflex, noop, reflexId) {

    if (reflex !== 'TranscriptionReflex#play_audio') {
      // Only proceed if the main element does not have the 'nowait' class
      if (!element.classList.contains('nowait')) {

        // Handle case where element itself is a button (e.g., reprocess button)
        if (element.tagName === 'BUTTON') {
          element.classList.add('reflex-pending');
          element.disabled = true;
        }

        // Get all buttons inside the element
        const buttons = element.querySelectorAll('button');

        buttons.forEach(button => {
          // Check if the individual button doesn't have a 'nowait' class
          if (!button.classList.contains('nowait')) {

            const icon = button.querySelector('i');

            if (icon) {
              icon.setAttribute("class", "bi");
              icon.classList.add('busy');
              icon.classList.add('d-inline-block');
              icon.classList.add('bi-arrow-repeat');
            }
            button.disabled = true;
          }
        });
      }
    }
  }
  

  afterReflex(element, reflex) {
    if (reflex !== 'TranscriptionReflex#play_audio') {
      // Add typing effect if hiddentext element exists
      if (this.hasHiddenTextTarget) {
        const textToType = this.hiddenTextTarget.textContent;
        this.typeText(this.outputTarget, textToType);
      }

      // Hide all buttons without the 'nowait' class
      if (!element.classList.contains('nowait')) {
        const buttons = element.querySelectorAll('button');
        buttons.forEach(button => {
          // Check if the individual button doesn't have a 'nowait' class
          if (!button.classList.contains('nowait')) {
            button.style.display = "none";
          }
        });
      }
    }
  }

  typeText(element, text, index = 0, delay = 20) {
    if (index < text.length) {
      element.textContent += text.charAt(index);
      setTimeout(() => this.typeText(element, text, index + 1, delay), delay);
    }
  }

  
}
